/* ═══════════════════════════════════════════════════════════════
   HERBAL CUP TEA — FAQ Page Script
   Accordion, Category Tabs, Search Filter, URL Hash Routing
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── References ── */
  var allTriggers  = document.querySelectorAll('.faq-item__trigger');
  var tabs         = document.querySelectorAll('.faq-filter__tab');
  var categories   = document.querySelectorAll('.faq-category');
  var searchInput  = document.getElementById('faq-search');
  var clearBtn     = document.getElementById('faq-search-clear');
  var noResults    = document.getElementById('faq-no-results');


  /* ═══════════════════════════════════════════
     ACCORDION (multiple can be open)
     Event-delegated — works even if triggers are added/re-rendered after
     this script initialises, and bypasses any timing race with `defer`.
     ═══════════════════════════════════════════ */
  function toggleAccordion(trigger) {
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    trigger.setAttribute('aria-expanded', String(!isExpanded));
    if (isExpanded) {
      panel.setAttribute('hidden', '');
    } else {
      panel.removeAttribute('hidden');
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.faq-item__trigger');
    if (trigger) toggleAccordion(trigger);
  });


  /* ═══════════════════════════════════════════
     CATEGORY TABS
     ═══════════════════════════════════════════ */
  function activateTab(category) {
    /* Update tab UI */
    tabs.forEach(function (t) {
      var isActive = t.dataset.category === category;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', String(isActive));
    });

    /* Show / hide category sections */
    categories.forEach(function (section) {
      section.hidden = (category !== 'all' && section.dataset.category !== category);
    });

    /* Show all items within visible categories (clear search effect) */
    document.querySelectorAll('.faq-item').forEach(function (item) {
      item.hidden = false;
    });

    /* Clear search */
    clearSearch();

    /* Update URL hash */
    if (category !== 'all') {
      history.replaceState(null, '', '#' + category);
    } else {
      history.replaceState(null, '', window.location.pathname);
    }

    /* Hide no-results */
    if (noResults) noResults.hidden = true;
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateTab(tab.dataset.category);
    });
  });

  /* Keyboard: arrow keys between tabs */
  tabs.forEach(function (tab, index) {
    tab.addEventListener('keydown', function (e) {
      var newIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        newIndex = (index + 1) % tabs.length;
        tabs[newIndex].focus();
        tabs[newIndex].click();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        newIndex = (index - 1 + tabs.length) % tabs.length;
        tabs[newIndex].focus();
        tabs[newIndex].click();
      }
    });
  });


  /* ═══════════════════════════════════════════
     SEARCH FILTER
     ═══════════════════════════════════════════ */
  function handleSearch() {
    var query = searchInput.value.trim().toLowerCase();

    /* Show/hide clear button */
    if (clearBtn) clearBtn.hidden = query.length === 0;

    /* Reset to "All" tab */
    tabs.forEach(function (t) {
      t.classList.toggle('active', t.dataset.category === 'all');
      t.setAttribute('aria-selected', String(t.dataset.category === 'all'));
    });

    /* Show all categories */
    categories.forEach(function (s) { s.hidden = false; });

    if (query.length === 0) {
      document.querySelectorAll('.faq-item').forEach(function (item) { item.hidden = false; });
      if (noResults) noResults.hidden = true;
      return;
    }

    /* Filter items */
    var matchCount = 0;
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var question = (item.querySelector('.faq-item__question') || {}).textContent || '';
      var answer   = (item.querySelector('.faq-item__answer') || {}).textContent || '';
      var matches  = question.toLowerCase().indexOf(query) !== -1 ||
                     answer.toLowerCase().indexOf(query) !== -1;

      item.hidden = !matches;
      if (matches) matchCount++;
    });

    /* Hide empty categories */
    categories.forEach(function (section) {
      var visible = section.querySelectorAll('.faq-item:not([hidden])');
      section.hidden = visible.length === 0;
    });

    /* No-results message */
    if (noResults) noResults.hidden = matchCount > 0;
  }

  function clearSearch() {
    if (searchInput) {
      searchInput.value = '';
      if (clearBtn) clearBtn.hidden = true;
    }
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  if (searchInput) {
    searchInput.addEventListener('input', debounce(handleSearch, 200));
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        clearSearch();
        handleSearch();
        searchInput.blur();
      }
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      clearSearch();
      handleSearch();
      searchInput.focus();
    });
  }


  /* ═══════════════════════════════════════════
     URL HASH ROUTING
     ═══════════════════════════════════════════ */
  function handleHash() {
    var hash = window.location.hash.slice(1);
    if (!hash) return;

    /* Check if hash matches a category tab */
    var matchingTab = document.querySelector('.faq-filter__tab[data-category="' + hash + '"]');
    if (matchingTab) {
      activateTab(hash);
      return;
    }

    /* Check if hash matches a FAQ item id */
    var matchingItem = document.getElementById(hash);
    if (matchingItem && matchingItem.classList.contains('faq-item')) {
      var trigger = matchingItem.querySelector('.faq-item__trigger');
      if (trigger && trigger.getAttribute('aria-expanded') !== 'true') {
        toggleAccordion(trigger);
      }
      /* Smooth scroll with offset for sticky header + filter */
      setTimeout(function () {
        var headerH = (document.querySelector('.header-wrapper') || {}).offsetHeight || 72;
        var filterH = (document.getElementById('faq-filter') || {}).offsetHeight || 60;
        var offset  = headerH + filterH + 16;
        var top = matchingItem.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 100);
    }
  }

  handleHash();
  window.addEventListener('hashchange', handleHash);

})();
